import { z } from 'zod';

const TournamentUserSchema = z.object({
  participant: z.boolean(),
  qualified: z.boolean(),
  qualificationProgress: z.object({
    bets: z.number().nullable(),
    qualificationBets: z.number().nullable(),
    potentialPoints: z.number().nullable()
  }),
  blocked: z.boolean()
});

const LeaderboardSchema = z.object({
  place: z.number(),
  userId: z.number(),
  points: z.number()
});

const TournamentSchema = z.object({
  id: z.number(),
  name: z.string(),
  status: z.string(),
  dateStart: z.string(),
  dateEnd: z.string(),
  types: z.array(z.string()),
  user: TournamentUserSchema,
  leaderboard: z.array(LeaderboardSchema).nullable()
});

export const GetTournamentsResponseSchema = z.object({
  status: z.enum(['success', 'error']),
  data: z.object({
    tournaments: z.array(TournamentSchema)
  })
});
